import * as React from 'react';
import { observer } from 'mobx-react';
import { Employee } from 'nomst/Stores/Decision/employee';
import { EmployeeDetailsCard } from '@payscale/payscale-shared-ui/lib/EmployeeDetailsCards';
import { dateFormat } from 'common/date-operation';
import './employeeInfoView.scss';

export interface IEmployeeInfoView {
    employee: Nullable<Employee>;
}

export class EmployeeInfoView extends React.Component<IEmployeeInfoView> {

    render(): React.ReactNode {
        return (
            <div className="nomst-employee-info-view">
                {this.renderBasicInfo()}
            </div>
        );
    }

    // EmployeeDetailsCard expects a format string parameter
    // However, payscale-shared-ui is on an older version of datefns
    // so we must override the format string here
    // eslint-disable-next-line no-unused-vars
    private formatDate(date: string, formatString: string): string {
        return dateFormat(new Date(date), 'MMMM dd, yyyy');
    }

    private renderBasicInfo(): React.ReactNode {
        const { employee } = this.props;
        if (!employee || !employee.employeeInfo) {
            return null; // Need a no data screen
        }

        return (
            <div className="employee-info-container">
                <h3>Basic Info</h3>
                <EmployeeDetailsCard
                    employeeId={employee.employeeSourceId}
                    dateOfHire={employee.hireDate}
                    managerName={employee.employeeInfo.managerDisplayName}
                    department={employee.employeeInfo.department}
                    email={employee.employeeInfo.workEmail}
                    workLocation={employee.workLocation}
                    dateFormatter={this.formatDate}
                />
            </div>
        );
    }
}

export default observer(EmployeeInfoView);